import { Component, type ErrorInfo, type ReactNode } from "react"

interface ErrorBoundaryState {
  error?: Error
}

/**
 * Last line of defence: a rendering error in one page shows a readable fallback
 * instead of a blank screen, and the relay layer keeps running.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = {}

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[jumble] render error", error, info.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="empty-state error-state" role="alert">
        <h2>Something went wrong</h2>
        <p>{this.state.error.message}</p>
        <div className="empty-state-action">
          <button type="button" className="btn btn-primary" onClick={() => this.setState({ error: undefined })}>
            Try again
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => window.location.assign("/")}>
            Back home
          </button>
        </div>
      </div>
    )
  }
}
